import { InverseTableBackground } from '../interface/bootstrap-table';

export const inverseTableBackground: InverseTableBackground[] = [
	{
		id: 1,
		first_name: 'Ram Jacob',
		last_name: 'Wolfe',
		company: 'Apple Inc.',
		credit_volume: '$3500.00',
		user_name: 'RamJacob@twitter',
		role: 'Developer',
		country: 'IND'
	},
	{
		id: 2,
		first_name: 'John Deo',
		last_name: 'Gummer',
		company: 'Hewlett packard',
		credit_volume: '$2400.00',
		user_name: 'JohnDeo@twitter',
		role: 'Designer',
		country: 'US'
	},
	{
		id: 3,
		first_name: 'Elana John',
		last_name: 'Wolfe',
		company: 'Microsoft',
		credit_volume: '$2560.00',
		user_name: 'ElanaJohn@twitter',
		role: 'Designer',
		country: 'UK'
	},
	{
		id: 4,
		first_name: 'Meryl Streep',
		last_name: 'Roberts',
		company: 'Tata Ltd.',
		credit_volume: '$1870.00',
		user_name: 'MerylStreep@twitter',
		role: 'Developer',
		country: 'IND'
	},
	{
		id: 5,
		first_name: 'Emma Stone',
		last_name: 'Stone',
		company: 'Wipro Ltd.',
		credit_volume: '$4580.00',
		user_name: 'EmmaStone@twitter',
		role: 'Developer',
		country: 'IRN'
	},
	{
		id: 6,
		first_name: 'Eliana Jons',
		last_name: 'Jons',
		company: 'Info Ltd.',
		credit_volume: '$4580.00',
		user_name: 'ElianaJons@twitter',
		role: 'Developer',
		country: 'IRN'
	}
];
